export default __webpack_public_path__ + "static/media/slider_image_02-xs@2x.fa4b364b.webp";